import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

const Blog = () => {
  const posts = [
    {
      id: "how-to-qualify-for-business-funding",
      title: "How to Qualify for Business Funding in 2026",
      excerpt:
        "Learn the key requirements lenders look for and how to position your business for approval.",
      date: "January 28, 2026",
      readTime: "5 min read",
      category: "Funding Tips",
    },
    {
      id: "mca-vs-term-loan",
      title: "Merchant Cash Advance vs. Term Loan: Which Is Right for You?",
      excerpt:
        "Understanding the differences between these two popular funding options can save you thousands.",
      date: "January 20, 2026",
      readTime: "4 min read",
      category: "Funding Options",
    },
    {
      id: "improve-business-cash-flow",
      title: "5 Ways to Improve Your Business Cash Flow",
      excerpt:
        "Practical strategies to keep money moving and your business thriving.",
      date: "January 15, 2026",
      readTime: "6 min read",
      category: "Business Tips",
    },
    {
      id: "when-to-seek-business-funding",
      title: "When Is the Right Time to Seek Business Funding?",
      excerpt:
        "Timing matters. Learn the signs that indicate your business is ready for outside capital.",
      date: "January 8, 2026",
      readTime: "4 min read",
      category: "Funding Tips",
    },
  ];

  return (
    <>
      <SEO
        title="Blog"
        description="Business funding tips, industry insights, and financial guidance from Lloyd Funding."
        canonical="/blog"
      />
      {/* Hero Section */}
      <section className="relative bg-gradient-to-b from-blue-50 to-white">
        <div className="mx-auto max-w-7xl px-4 pt-20 pb-12 sm:px-6 sm:pt-24 sm:pb-12 lg:px-8 lg:pt-24 lg:pb-16">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="text-3xl font-bold tracking-tight text-slate-800 sm:text-4xl lg:text-5xl">
              Our <span className="text-blue-700">Blog</span>
            </h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Insights, tips, and guides to help your business grow and thrive.
            </p>
          </div>
        </div>

        {/* Wave divider */}
        <div className="pointer-events-none relative h-10 overflow-hidden">
          <svg
            className="absolute bottom-0 left-0 h-16 w-full"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
            aria-hidden="true"
          >
            <path
              d="M0,64 C288,110 576,110 864,80 C1152,50 1296,50 1440,80 L1440,120 L0,120 Z"
              fill="#FFFFFF"
            />
          </svg>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-20">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {posts.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.id}`}
                className="group rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition-shadow duration-200 hover:shadow-xl hover:ring-1 hover:ring-blue-100"
              >
                <div className="flex items-center gap-3 text-sm">
                  <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700">
                    {post.category}
                  </span>
                  <span className="text-slate-400">{post.readTime}</span>
                </div>

                <h2 className="mt-4 text-xl font-bold text-slate-800 group-hover:text-blue-700 transition">
                  {post.title}
                </h2>

                <p className="mt-2 text-slate-600 leading-relaxed">
                  {post.excerpt}
                </p>

                <div className="mt-4 flex items-center justify-between">
                  <span className="text-sm text-slate-400">{post.date}</span>
                  <span className="inline-flex items-center text-sm font-medium text-blue-600 group-hover:text-blue-700">
                    Read more
                    <svg
                      className="ml-1 h-4 w-4 transition group-hover:translate-x-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                      />
                    </svg>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-slate-50">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-20">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-2xl font-bold text-slate-800 sm:text-3xl">
              Ready to grow your business?
            </h2>
            <p className="mt-4 text-lg text-slate-600">
              Apply today and get funded as soon as the same day.
            </p>
            <div className="mt-8">
              <Link
                to="/contact#application-form"
                className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white shadow-sm shadow-blue-600/25 hover:bg-blue-700 transition"
              >
                Apply Now
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
